/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  MealType,
  mealTypeToNumber,
  mealTypeFromJSON,
  mealTypeToJSON,
} from "./MealType";
import {
  MealCategory,
  mealCategoryToNumber,
  mealCategoryFromJSON,
  mealCategoryToJSON,
} from "./MealCategory/MealCategory";
import {
  TransferType,
  transferTypeToNumber,
  transferTypeFromJSON,
  transferTypeToJSON,
} from "./Accommodation/TransferType";
import {
  ViewType,
  viewTypeToNumber,
  viewTypeFromJSON,
  viewTypeToJSON,
} from "./Accommodation/ViewType";
import {
  PoolType,
  poolTypeToNumber,
  poolTypeFromJSON,
  poolTypeToJSON,
} from "./Accommodation/PoolType";
import {
  Exterior,
  exteriorToNumber,
  exteriorFromJSON,
  exteriorToJSON,
} from "./Accommodation/Exterior";
import {
  RoomClass,
  roomClassToNumber,
  roomClassFromJSON,
  roomClassToJSON,
} from "./RoomClass";
import {
  RoomType,
  roomTypeToNumber,
  roomTypeFromJSON,
  roomTypeToJSON,
} from "./Room/RoomType";
import { RoomSummary } from "../Price/PriceTree";
import {
  TravellerType,
  travellerTypeToNumber,
  travellerTypeFromJSON,
  travellerTypeToJSON,
} from "../TravellerType";

export interface AccommodationData {
  hasRailAndFly: boolean;
  mealType: MealType;
  mealCategory: MealCategory;
  roomDescription?: AccommodationData_RoomDescription;
  transfer: TransferType;
  unit?: AccommodationData_Unit;
  view: ViewType;
  pool: PoolType;
  exterior: Exterior;
  roomList: AccommodationData_Room[];
  includedSurcharges: string[];
}

export interface AccommodationData_RoomDescription {
  /** whether this room is in an annex building or not */
  isAnnexBuilding: boolean;
  /** whether room class should be shown */
  showRoomClass: boolean;
  /**
   * use the type enum and map the label from there instead
   *
   * @deprecated
   */
  name: string;
  /** the supplier room description */
  description: string;
  /**
   * the tooltip data used to render the room tooltip in S4
   *
   * @deprecated
   */
  tooltipData: string;
  /** roomClass */
  class: RoomClass;
  type: RoomType;
}

export interface AccommodationData_Unit {
  id: number;
  livingSpace: number;
  name: string;
  label: string;
}

export interface AccommodationData_Room {
  roomContentId: string;
  roomPreview: string;
  roomDescription?: AccommodationData_RoomDescription;
  /** the room price summary */
  priceSummary?: RoomSummary;
  /** the travellers within the room */
  travellerList: AccommodationData_Room_Traveller[];
}

export interface AccommodationData_Room_Traveller {
  /** the traveller type */
  type: TravellerType;
  /** the age of the traveller */
  age: number;
  /** the traveller price */
  price: number;
}

function createBaseAccommodationData(): AccommodationData {
  return {
    hasRailAndFly: false,
    mealType: MealType.MealTypeUnknown,
    mealCategory: MealCategory.MealCategoryUnknown,
    roomDescription: undefined,
    transfer: TransferType.NoTransfer,
    unit: undefined,
    view: ViewType.UnknownView,
    pool: PoolType.UnknownPoolType,
    exterior: Exterior.UnknownExterior,
    roomList: [],
    includedSurcharges: [],
  };
}

export const AccommodationData = {
  encode(
    message: AccommodationData,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.hasRailAndFly === true) {
      writer.uint32(40).bool(message.hasRailAndFly);
    }
    if (message.mealType !== MealType.MealTypeUnknown) {
      writer.uint32(8).int32(mealTypeToNumber(message.mealType));
    }
    if (message.mealCategory !== MealCategory.MealCategoryUnknown) {
      writer.uint32(96).int32(mealCategoryToNumber(message.mealCategory));
    }
    if (message.roomDescription !== undefined) {
      AccommodationData_RoomDescription.encode(
        message.roomDescription,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.transfer !== TransferType.NoTransfer) {
      writer.uint32(32).int32(transferTypeToNumber(message.transfer));
    }
    if (message.unit !== undefined) {
      AccommodationData_Unit.encode(
        message.unit,
        writer.uint32(66).fork()
      ).ldelim();
    }
    if (message.view !== ViewType.UnknownView) {
      writer.uint32(72).int32(viewTypeToNumber(message.view));
    }
    if (message.pool !== PoolType.UnknownPoolType) {
      writer.uint32(80).int32(poolTypeToNumber(message.pool));
    }
    if (message.exterior !== Exterior.UnknownExterior) {
      writer.uint32(88).int32(exteriorToNumber(message.exterior));
    }
    for (const v of message.roomList) {
      AccommodationData_Room.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.includedSurcharges) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccommodationData {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 5:
          message.hasRailAndFly = reader.bool();
          break;
        case 1:
          message.mealType = mealTypeFromJSON(reader.int32());
          break;
        case 12:
          message.mealCategory = mealCategoryFromJSON(reader.int32());
          break;
        case 2:
          message.roomDescription = AccommodationData_RoomDescription.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.transfer = transferTypeFromJSON(reader.int32());
          break;
        case 8:
          message.unit = AccommodationData_Unit.decode(reader, reader.uint32());
          break;
        case 9:
          message.view = viewTypeFromJSON(reader.int32());
          break;
        case 10:
          message.pool = poolTypeFromJSON(reader.int32());
          break;
        case 11:
          message.exterior = exteriorFromJSON(reader.int32());
          break;
        case 6:
          message.roomList.push(
            AccommodationData_Room.decode(reader, reader.uint32())
          );
          break;
        case 7:
          message.includedSurcharges.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationData {
    return {
      hasRailAndFly: isSet(object.hasRailAndFly)
        ? Boolean(object.hasRailAndFly)
        : false,
      mealType: isSet(object.mealType)
        ? mealTypeFromJSON(object.mealType)
        : MealType.MealTypeUnknown,
      mealCategory: isSet(object.mealCategory)
        ? mealCategoryFromJSON(object.mealCategory)
        : MealCategory.MealCategoryUnknown,
      roomDescription: isSet(object.roomDescription)
        ? AccommodationData_RoomDescription.fromJSON(object.roomDescription)
        : undefined,
      transfer: isSet(object.transfer)
        ? transferTypeFromJSON(object.transfer)
        : TransferType.NoTransfer,
      unit: isSet(object.unit)
        ? AccommodationData_Unit.fromJSON(object.unit)
        : undefined,
      view: isSet(object.view)
        ? viewTypeFromJSON(object.view)
        : ViewType.UnknownView,
      pool: isSet(object.pool)
        ? poolTypeFromJSON(object.pool)
        : PoolType.UnknownPoolType,
      exterior: isSet(object.exterior)
        ? exteriorFromJSON(object.exterior)
        : Exterior.UnknownExterior,
      roomList: Array.isArray(object?.roomList)
        ? object.roomList.map((e: any) => AccommodationData_Room.fromJSON(e))
        : [],
      includedSurcharges: Array.isArray(object?.includedSurcharges)
        ? object.includedSurcharges.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: AccommodationData): unknown {
    const obj: any = {};
    message.hasRailAndFly !== undefined &&
      (obj.hasRailAndFly = message.hasRailAndFly);
    message.mealType !== undefined &&
      (obj.mealType = mealTypeToJSON(message.mealType));
    message.mealCategory !== undefined &&
      (obj.mealCategory = mealCategoryToJSON(message.mealCategory));
    message.roomDescription !== undefined &&
      (obj.roomDescription = message.roomDescription
        ? AccommodationData_RoomDescription.toJSON(message.roomDescription)
        : undefined);
    message.transfer !== undefined &&
      (obj.transfer = transferTypeToJSON(message.transfer));
    message.unit !== undefined &&
      (obj.unit = message.unit
        ? AccommodationData_Unit.toJSON(message.unit)
        : undefined);
    message.view !== undefined && (obj.view = viewTypeToJSON(message.view));
    message.pool !== undefined && (obj.pool = poolTypeToJSON(message.pool));
    message.exterior !== undefined &&
      (obj.exterior = exteriorToJSON(message.exterior));
    if (message.roomList) {
      obj.roomList = message.roomList.map((e) =>
        e ? AccommodationData_Room.toJSON(e) : undefined
      );
    } else {
      obj.roomList = [];
    }
    if (message.includedSurcharges) {
      obj.includedSurcharges = message.includedSurcharges.map((e) => e);
    } else {
      obj.includedSurcharges = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<AccommodationData>): AccommodationData {
    const message = createBaseAccommodationData();
    message.hasRailAndFly = object.hasRailAndFly ?? false;
    message.mealType = object.mealType ?? MealType.MealTypeUnknown;
    message.mealCategory =
      object.mealCategory ?? MealCategory.MealCategoryUnknown;
    message.roomDescription =
      object.roomDescription !== undefined && object.roomDescription !== null
        ? AccommodationData_RoomDescription.fromPartial(object.roomDescription)
        : undefined;
    message.transfer = object.transfer ?? TransferType.NoTransfer;
    message.unit =
      object.unit !== undefined && object.unit !== null
        ? AccommodationData_Unit.fromPartial(object.unit)
        : undefined;
    message.view = object.view ?? ViewType.UnknownView;
    message.pool = object.pool ?? PoolType.UnknownPoolType;
    message.exterior = object.exterior ?? Exterior.UnknownExterior;
    message.roomList =
      object.roomList?.map((e) => AccommodationData_Room.fromPartial(e)) || [];
    message.includedSurcharges = object.includedSurcharges?.map((e) => e) || [];
    return message;
  },
};

function createBaseAccommodationData_RoomDescription(): AccommodationData_RoomDescription {
  return {
    isAnnexBuilding: false,
    showRoomClass: false,
    name: "",
    description: "",
    tooltipData: "",
    class: RoomClass.Standard,
    type: RoomType.RoomTypeUnknown,
  };
}

export const AccommodationData_RoomDescription = {
  encode(
    message: AccommodationData_RoomDescription,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isAnnexBuilding === true) {
      writer.uint32(32).bool(message.isAnnexBuilding);
    }
    if (message.showRoomClass === true) {
      writer.uint32(48).bool(message.showRoomClass);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.tooltipData !== "") {
      writer.uint32(66).string(message.tooltipData);
    }
    if (message.class !== RoomClass.Standard) {
      writer.uint32(40).int32(roomClassToNumber(message.class));
    }
    if (message.type !== RoomType.RoomTypeUnknown) {
      writer.uint32(56).int32(roomTypeToNumber(message.type));
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationData_RoomDescription {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationData_RoomDescription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.isAnnexBuilding = reader.bool();
          break;
        case 6:
          message.showRoomClass = reader.bool();
          break;
        case 2:
          message.name = reader.string();
          break;
        case 3:
          message.description = reader.string();
          break;
        case 8:
          message.tooltipData = reader.string();
          break;
        case 5:
          message.class = roomClassFromJSON(reader.int32());
          break;
        case 7:
          message.type = roomTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationData_RoomDescription {
    return {
      isAnnexBuilding: isSet(object.isAnnexBuilding)
        ? Boolean(object.isAnnexBuilding)
        : false,
      showRoomClass: isSet(object.showRoomClass)
        ? Boolean(object.showRoomClass)
        : false,
      name: isSet(object.name) ? String(object.name) : "",
      description: isSet(object.description) ? String(object.description) : "",
      tooltipData: isSet(object.tooltipData) ? String(object.tooltipData) : "",
      class: isSet(object.class)
        ? roomClassFromJSON(object.class)
        : RoomClass.Standard,
      type: isSet(object.type)
        ? roomTypeFromJSON(object.type)
        : RoomType.RoomTypeUnknown,
    };
  },

  toJSON(message: AccommodationData_RoomDescription): unknown {
    const obj: any = {};
    message.isAnnexBuilding !== undefined &&
      (obj.isAnnexBuilding = message.isAnnexBuilding);
    message.showRoomClass !== undefined &&
      (obj.showRoomClass = message.showRoomClass);
    message.name !== undefined && (obj.name = message.name);
    message.description !== undefined &&
      (obj.description = message.description);
    message.tooltipData !== undefined &&
      (obj.tooltipData = message.tooltipData);
    message.class !== undefined && (obj.class = roomClassToJSON(message.class));
    message.type !== undefined && (obj.type = roomTypeToJSON(message.type));
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationData_RoomDescription>
  ): AccommodationData_RoomDescription {
    const message = createBaseAccommodationData_RoomDescription();
    message.isAnnexBuilding = object.isAnnexBuilding ?? false;
    message.showRoomClass = object.showRoomClass ?? false;
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.tooltipData = object.tooltipData ?? "";
    message.class = object.class ?? RoomClass.Standard;
    message.type = object.type ?? RoomType.RoomTypeUnknown;
    return message;
  },
};

function createBaseAccommodationData_Unit(): AccommodationData_Unit {
  return { id: 0, livingSpace: 0, name: "", label: "" };
}

export const AccommodationData_Unit = {
  encode(
    message: AccommodationData_Unit,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.livingSpace !== 0) {
      writer.uint32(32).uint32(message.livingSpace);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationData_Unit {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationData_Unit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.uint32();
          break;
        case 4:
          message.livingSpace = reader.uint32();
          break;
        case 2:
          message.name = reader.string();
          break;
        case 3:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationData_Unit {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      livingSpace: isSet(object.livingSpace) ? Number(object.livingSpace) : 0,
      name: isSet(object.name) ? String(object.name) : "",
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: AccommodationData_Unit): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = Math.round(message.id));
    message.livingSpace !== undefined &&
      (obj.livingSpace = Math.round(message.livingSpace));
    message.name !== undefined && (obj.name = message.name);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationData_Unit>
  ): AccommodationData_Unit {
    const message = createBaseAccommodationData_Unit();
    message.id = object.id ?? 0;
    message.livingSpace = object.livingSpace ?? 0;
    message.name = object.name ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseAccommodationData_Room(): AccommodationData_Room {
  return {
    roomContentId: "",
    roomPreview: "",
    roomDescription: undefined,
    priceSummary: undefined,
    travellerList: [],
  };
}

export const AccommodationData_Room = {
  encode(
    message: AccommodationData_Room,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.roomContentId !== "") {
      writer.uint32(34).string(message.roomContentId);
    }
    if (message.roomPreview !== "") {
      writer.uint32(42).string(message.roomPreview);
    }
    if (message.roomDescription !== undefined) {
      AccommodationData_RoomDescription.encode(
        message.roomDescription,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.priceSummary !== undefined) {
      RoomSummary.encode(
        message.priceSummary,
        writer.uint32(18).fork()
      ).ldelim();
    }
    for (const v of message.travellerList) {
      AccommodationData_Room_Traveller.encode(
        v!,
        writer.uint32(26).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationData_Room {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationData_Room();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.roomContentId = reader.string();
          break;
        case 5:
          message.roomPreview = reader.string();
          break;
        case 1:
          message.roomDescription = AccommodationData_RoomDescription.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.priceSummary = RoomSummary.decode(reader, reader.uint32());
          break;
        case 3:
          message.travellerList.push(
            AccommodationData_Room_Traveller.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationData_Room {
    return {
      roomContentId: isSet(object.roomContentId)
        ? String(object.roomContentId)
        : "",
      roomPreview: isSet(object.roomPreview) ? String(object.roomPreview) : "",
      roomDescription: isSet(object.roomDescription)
        ? AccommodationData_RoomDescription.fromJSON(object.roomDescription)
        : undefined,
      priceSummary: isSet(object.priceSummary)
        ? RoomSummary.fromJSON(object.priceSummary)
        : undefined,
      travellerList: Array.isArray(object?.travellerList)
        ? object.travellerList.map((e: any) =>
            AccommodationData_Room_Traveller.fromJSON(e)
          )
        : [],
    };
  },

  toJSON(message: AccommodationData_Room): unknown {
    const obj: any = {};
    message.roomContentId !== undefined &&
      (obj.roomContentId = message.roomContentId);
    message.roomPreview !== undefined &&
      (obj.roomPreview = message.roomPreview);
    message.roomDescription !== undefined &&
      (obj.roomDescription = message.roomDescription
        ? AccommodationData_RoomDescription.toJSON(message.roomDescription)
        : undefined);
    message.priceSummary !== undefined &&
      (obj.priceSummary = message.priceSummary
        ? RoomSummary.toJSON(message.priceSummary)
        : undefined);
    if (message.travellerList) {
      obj.travellerList = message.travellerList.map((e) =>
        e ? AccommodationData_Room_Traveller.toJSON(e) : undefined
      );
    } else {
      obj.travellerList = [];
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationData_Room>
  ): AccommodationData_Room {
    const message = createBaseAccommodationData_Room();
    message.roomContentId = object.roomContentId ?? "";
    message.roomPreview = object.roomPreview ?? "";
    message.roomDescription =
      object.roomDescription !== undefined && object.roomDescription !== null
        ? AccommodationData_RoomDescription.fromPartial(object.roomDescription)
        : undefined;
    message.priceSummary =
      object.priceSummary !== undefined && object.priceSummary !== null
        ? RoomSummary.fromPartial(object.priceSummary)
        : undefined;
    message.travellerList =
      object.travellerList?.map((e) =>
        AccommodationData_Room_Traveller.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseAccommodationData_Room_Traveller(): AccommodationData_Room_Traveller {
  return { type: TravellerType.TravellerTypeUnknown, age: 0, price: 0 };
}

export const AccommodationData_Room_Traveller = {
  encode(
    message: AccommodationData_Room_Traveller,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.type !== TravellerType.TravellerTypeUnknown) {
      writer.uint32(8).int32(travellerTypeToNumber(message.type));
    }
    if (message.age !== 0) {
      writer.uint32(16).uint32(message.age);
    }
    if (message.price !== 0) {
      writer.uint32(29).float(message.price);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationData_Room_Traveller {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationData_Room_Traveller();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.type = travellerTypeFromJSON(reader.int32());
          break;
        case 2:
          message.age = reader.uint32();
          break;
        case 3:
          message.price = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationData_Room_Traveller {
    return {
      type: isSet(object.type)
        ? travellerTypeFromJSON(object.type)
        : TravellerType.TravellerTypeUnknown,
      age: isSet(object.age) ? Number(object.age) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
    };
  },

  toJSON(message: AccommodationData_Room_Traveller): unknown {
    const obj: any = {};
    message.type !== undefined &&
      (obj.type = travellerTypeToJSON(message.type));
    message.age !== undefined && (obj.age = Math.round(message.age));
    message.price !== undefined && (obj.price = message.price);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationData_Room_Traveller>
  ): AccommodationData_Room_Traveller {
    const message = createBaseAccommodationData_Room_Traveller();
    message.type = object.type ?? TravellerType.TravellerTypeUnknown;
    message.age = object.age ?? 0;
    message.price = object.price ?? 0;
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
